import { Children } from 'react';
import cloneElement from './cloneElement';

export default function cloneChildren(children = null, ...props) {
    return Children.map(children, (child) => cloneElement(child, ...props));
}
